import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { MapProvider } from './contexts/MapContext';
import MainLayout from './components/Layout/MainLayout';
import MapContainer from './components/Map/MapContainer';
import theme from './styles/theme';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MapProvider>
        <MainLayout>
          <MapContainer />
        </MainLayout>
      </MapProvider>
    </ThemeProvider>
  );
};

export default App;